/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

  __webpack_require__.r(__webpack_exports__);
  /* harmony export */ __webpack_require__.d(__webpack_exports__, {
  /* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
  /* harmony export */ });
  // ---------------------------------------------------------------------------
  // Money format handler
  // ---------------------------------------------------------------------------
  function formatMoney(cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
  
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "${{amount}}";
  
    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
  
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
  
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
  
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
  
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }
  ;
  
  /***/ }),
  
  /***/ "./node_modules/smooth-zoom/dist/zoom.esm.js":
  /*!***************************************************!*\
    !*** ./node_modules/smooth-zoom/dist/zoom.esm.js ***!
    \***************************************************/
  /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
  
  __webpack_require__.r(__webpack_exports__);
  /* harmony export */ __webpack_require__.d(__webpack_exports__, {
  /* harmony export */   "default": () => (/* binding */ Zoom)
  /* harmony export */ });
  function Zoom(target, options = {}) {
    const originalizer = options.originalizer || (src => src);
  
    const screenSize = {
      screenWidth: 0,
      screenHeight: 0,
      scrollBar: 0
    };
    const background = options.background;
  
    const updateScreenSize = () => {
      const {
        documentElement
      } = document;
      screenSize.screenWidth = window.innerWidth || documentElement.clientWidth;
      screenSize.screenHeight = window.innerHeight || documentElement.clientHeight;
      screenSize.scrollBar = screenSize.screenWidth - documentElement.offsetWidth;
    };
  
    const zoom = image => {
      const src = image.currentSrc || image.src;
      const {
        srcset
      } = image;
      const {
        screenWidth,
        screenHeight,
        scrollBar
      } = screenSize;
      const {
        width,
        height,
        left,
        top
      } = image.getBoundingClientRect();
      const wrapX = (screenWidth - scrollBar) / 2 - left - width / 2;
      const wrapY = -top + (screenHeight - height) / 2;
      const bg = document.createElement("div");
      const imageClone = document.createElement("img");
      let maxWidth = image.naturalWidth;
  
      const removeImage = () => {
        bg.classList.remove("zoom-bg--reveal");
        imageClone.style.transform = "";
        imageClone.addEventListener("transitionend", () => {
          bg.remove();
          image.classList.remove("zoom-original--hidden");
          imageClone.remove();
        }, {
          once: true
        });
        bg.removeEventListener("click", removeImage);
        imageClone.removeEventListener("click", removeImage);
        window.removeEventListener("scroll", removeImage);
        window.removeEventListener("resize", removeImage);
      };
  
      bg.classList.add("zoom-bg");
  
      if (background) {
        if (background === "auto") {
          const average = getAverageRGB(image);
          bg.style.background = average ? `rgb(${average.r}, ${average.g}, ${average.b})` : "rgb(0, 0, 0)";
        } else {
          bg.style.background = background;
        }
      }
  
      if (srcset) {
        const sizes = srcset.match(/ ([0-9]+)w/gm);
  
        if (sizes) {
          // Find image's largest width in 'srcset' attribute
          maxWidth = sizes.map(x => +x.trim().replace("w", "")).filter(x => !isNaN(x)).reduce((acc, cur) => Math.max(acc, cur), 0);
        }
      }
  
      const ratio = height / width; // Image's width shouldn't be larger than screen width
  
      maxWidth = Math.min(maxWidth, screenWidth); // And height too
  
      const maxHeight = maxWidth * ratio;
  
      if (maxHeight >= screenHeight) {
        maxWidth = maxWidth * screenHeight / maxHeight;
      }
  
      imageClone.classList.add("zoom-img");
      imageClone.src = src;
      imageClone.width = width;
      imageClone.height = height;
      bg.addEventListener("click", removeImage, {
        once: true
      });
      imageClone.addEventListener("click", removeImage, {
        once: true
      });
      window.addEventListener("scroll", removeImage, {
        once: true,
        passive: true
      });
      window.addEventListener("resize", removeImage, {
        once: true,
        passive: true
      });
      document.body.append(bg, imageClone); // Added here for causing style recalculation
  
      imageClone.style.top = `${top + window.scrollY}px`;
      imageClone.style.left = `${left}px`;
      imageClone.style.width = `${width}px`;
      imageClone.style.height = `${height}px`; // Hide original image
  
      image.classList.add("zoom-original--hidden"); // Reveal and center cloned image, scale up if needed
  
      const scale = maxWidth !== width ? maxWidth / width : 1;
      imageClone.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${wrapX}, ${wrapY})`;
      bg.classList.add("zoom-bg--reveal");
      imageClone.addEventListener("transitionend", () => {
        // Replace image's source to original source
        imageClone.src = originalizer(src);
      }, {
        once: true
      });
    };
  
    const handleClick = event => {
      zoom(event.target);
    };
  
    const getAverageRGB = img => {
      const blockSize = 5;
      const rgb = {
        r: 0,
        g: 0,
        b: 0
      };
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;
      const width = canvas.width = img.naturalWidth || img.offsetWidth || img.width;
      const height = canvas.height = img.naturalHeight || img.offsetHeight || img.height;
      let data;
      let i = -4;
      let length;
      let count = 0;
      ctx.drawImage(img, 0, 0);
  
      try {
        data = ctx.getImageData(0, 0, width, height);
      } catch (e) {
        return null;
      }
  
      length = data.data.length;
  
      while ((i += blockSize * 4) < length) {
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i + 1];
        rgb.b += data.data[i + 2];
      }
  
      rgb.r = Math.floor(rgb.r / count);
      rgb.g = Math.floor(rgb.g / count);
      rgb.b = Math.floor(rgb.b / count);
      return rgb;
    };
  
    const attach = target => {
      if (!target) return;
  
      if (typeof target === "string") {
        document.querySelectorAll(target).forEach(addZoomEvent);
      } else if (target instanceof HTMLElement) {
        addZoomEvent(target);
      } else if (target instanceof NodeList || target instanceof Array) {
        target.forEach(addZoomEvent);
      } // Add cursor style for target
  
  
      if (typeof target === "string") {
        const style = document.createElement("style");
        const head = document.head || document.getElementsByTagName("head")[0];
        style.appendChild(document.createTextNode(`${target}{cursor:zoom-in}`));
        head.appendChild(style);
      }
    };
  
    const addZoomEvent = element => {
      if (!(element instanceof HTMLElement)) return;
  
      if (element.tagName === "IMG") {
        element.addEventListener("click", handleClick);
      } else {
        const childImg = element.querySelector("img");
  
        if (childImg) {
          childImg.addEventListener("click", handleClick);
        }
      }
    };
  
    updateScreenSize();
    window.addEventListener("resize", updateScreenSize, {
      passive: true
    });
    attach(target);
    return {
      zoom,
      attach
    };
  }
  
  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
  
    if (!css || typeof document === 'undefined') {
      return;
    }
  
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
  
    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }
  
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }
  
  var css_248z = ".zoom-bg,.zoom-img{cursor:zoom-out;z-index:90000}.zoom-img{display:block;position:absolute;transition:transform .3s ease-in-out;will-change:transform}.zoom-bg{background:#121212;height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .3s ease-in-out;width:100vw;will-change:opacity}.zoom-bg.zoom-bg--reveal{opacity:.95}.zoom-original--hidden{visibility:hidden}";
  styleInject(css_248z);
  
  
  
  
  /***/ })
  
  /******/ 	});
  /************************************************************************/
  /******/ 	// The module cache
  /******/ 	var __webpack_module_cache__ = {};
  /******/ 	
  /******/ 	// The require function
  /******/ 	function __webpack_require__(moduleId) {
  /******/ 		// Check if module is in cache
  /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
  /******/ 		if (cachedModule !== undefined) {
  /******/ 			return cachedModule.exports;
  /******/ 		}
  /******/ 		// Create a new module (and put it into the cache)
  /******/ 		var module = __webpack_module_cache__[moduleId] = {
  /******/ 			// no module.id needed
  /******/ 			// no module.loaded needed
  /******/ 			exports: {}
  /******/ 		};
  /******/ 	
  /******/ 		// Execute the module function
  /******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
  /******/ 	
  /******/ 		// Return the exports of the module
  /******/ 		return module.exports;
  /******/ 	}
  /******/ 	
  /************************************************************************/
  /******/ 	/* webpack/runtime/define property getters */
  /******/ 	(() => {
  /******/ 		// define getter functions for harmony exports
  /******/ 		__webpack_require__.d = (exports, definition) => {
  /******/ 			for(var key in definition) {
  /******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
  /******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
  /******/ 				}
  /******/ 			}
  /******/ 		};
  /******/ 	})();
  /******/ 	
  /******/ 	/* webpack/runtime/hasOwnProperty shorthand */
  /******/ 	(() => {
  /******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
  /******/ 	})();
  /******/ 	
  /******/ 	/* webpack/runtime/make namespace object */
  /******/ 	(() => {
  /******/ 		// define __esModule on exports
  /******/ 		__webpack_require__.r = (exports) => {
  /******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
  /******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
  /******/ 			}
  /******/ 			Object.defineProperty(exports, '__esModule', { value: true });
  /******/ 		};
  /******/ 	})();
  /******/ 	
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
  (() => {
  /*!***************************!*\
    !*** ./src/js/product.js ***!
    \***************************/
  __webpack_require__.r(__webpack_exports__);
  /* harmony import */ var smooth_zoom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! smooth-zoom */ "./node_modules/smooth-zoom/dist/zoom.esm.js");
  /* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");
  function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
  
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
  
  
  
  /*
   BG: Init smooth-zoom, just apply the class below a zoomable image
  https://github.com/marshall-ku/smooth-zoom
   */
  
  (0,smooth_zoom__WEBPACK_IMPORTED_MODULE_0__["default"])(".zoomable");
  /**
   * BG: This is a BIG function, that has alot of smaller functions. The whole purpose of this is to determine the variant options the user has selected, while highlighting the available and unavailable variants after each choice they make, and updating the price, and variant id field. This function works best when we have the first available variants selected.
   */
  
  var productVariants = function productVariants() {
    var productVariants = document.querySelector('#product-variants');
    var radioBtns = productVariants.querySelectorAll('input[type="radio"]');
    var variantFieldsets = productVariants.querySelectorAll('fieldset');
    var masterVariantField = document.querySelector('.product-info form[action="/cart/add"] input[name="id"]');
    var cartBtn = document.querySelector('.product-info form[action="/cart/add"] button[type="submit"]'); //get the variantData from the json markup.
  
    var getVariantData = function getVariantData() {
      return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
    }; //Debug
    //console.log(JSON.parse(productVariants.querySelector('[type="application/json"]').textContent));
    //BG: When the user makes a selection, update the field legend to include that choice.
  
    /**
     * 
     * @param {*} radio | Node - Passed when the user selects a radio on variant selector.
     */
  
  
    var fieldsetLegend = function fieldsetLegend(radio) {
      var parentLegend = radio.closest('fieldset');
      var legendLabel = parentLegend.querySelector('legend').getAttribute('data-fieldset-label');
      parentLegend.querySelector('legend span').innerHTML = legendLabel + ': ' + '<span class="uppercase font-bold">' + radio.value + '</span>';
    }; //BG: Triggered by the finalVariant function, we determine if the final variant Id selected is available or not, and update the button to reflect that choice.
  
  
    var addToBagBtn = function addToBagBtn(available) {
      if (available) {
        cartBtn.classList.remove('btn-disabled');
        cartBtn.classList.add('btn-primary');
        cartBtn.innerHTML = window.product.addToCart;
        cartBtn.disabled = false;
      } else {
        cartBtn.classList.add('btn-disabled');
        cartBtn.classList.remove('btn-primary');
        cartBtn.innerHTML = window.product.soldOut;
        cartBtn.disabled = true;
      }
    }; //BG: the finalVariant funciton below will trigger this function, we essentially need the variant ID to query the price
  
  
    var variantPrice = function variantPrice(variantId) {
      var productPrice = document.querySelector('.js-product-price');
      var productCAP = document.querySelector('.js-product-compare-at-price');
      var variantData = getVariantData().filter(function (variant) {
        return variant.id === variantId;
      }); //Update the product price, with the selected variant, and format the money.
  
      productPrice.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].price, window.theme.moneyFormat); //Is there a Compare at price (CAP)? if so, let's update that too. 
  
      if (variantData[0].compare_at_price != null) {
        //if CAP does exist, remove the hidden class if present.
        productCAP.classList.remove('hidden'); //Update the CAP, with the selected variant, and format the money.
  
        productCAP.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].compare_at_price, window.theme.moneyFormat);
      } else {
        //No CAP?, No Problem, let's just hide it.
        productCAP.classList.add('hidden');
      }
    };
    /**
     * BG: Once the user has selected all variant options, this function then triggers to update the variant ID field, price and url based on the users choice. 
     */
  
  
    var finalVariant = function finalVariant(variant) {
      //BG: let's update the id input to the selected variant id
      masterVariantField.value = variant.id; //BG: Trigger the price update based on the variant ID
  
      variantPrice(variant.id); //BG: Update the add to bag btn based on the variant being available or not.
  
      addToBagBtn(variant.available); //Update the url with the user's variant choice.
      //Get the current URL without parameters
  
      var currentURLWithoutParams = window.location.href.split('?')[0]; //update the page url with paramters
  
      history.pushState(null, null, currentURLWithoutParams + '?variant=' + variant.id);
    };
    /**
     * BG: There's a lot going on here, basically we determine how many variant options there are, and based on how many options there are, will determine the logic and approach. Essentially, we're determining what options are available or not available based on the user's choice. 
     * checkedBtns(Array) - Checked radio buttons.
     */
  
  
    var remainingOptions = function remainingOptions(checkedBtns) {
      //If only one variant, remove all unavailable classes.
      if (variantFieldsets.length === 1) {
        productVariants.querySelectorAll('.js-unavailable-variant').forEach(function (label) {
          label.classList.remove('js-unavailable-variant');
        });
      } // for each checked radio button.
  
  
      checkedBtns.forEach(function (radio, index) {
        //First fieldset option
        if (index === 0) {
          //console.log('fire option 1');
          var remainingVariants; //if only one variant, then find all the unavailable variants
  
          if (variantFieldsets.length === 1) {
            remainingVariants = getVariantData().filter(function (variant) {
              return variant.available === false;
            });
          } else if (variantFieldsets.length === 2) {
            //if two variants, then find all the variants from option1 that match the selected radio option, and sort by unavailable first.
            remainingVariants = getVariantData().filter(function (variant) {
              return variant.option1 === checkedBtns[0].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          } else if (variantFieldsets.length > 2) {
            //if three variants, find all the variants from option1 and option2 that match the selected values for 1 & 2, and sort by unavailable first.
            remainingVariants = getVariantData().filter(function (variant) {
              return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          } //console.log(index);
          //console.log({remainingVariants});
  
  
          remainingVariants.forEach(function (variant) {
            //if one variant, highlight the unavailable options.
            if (variantFieldsets.length === 1) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
            } //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
  
  
            if (variantFieldsets.length >= 2) {
              if (variant.available) {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
              }
            } //if there is three variants, same as above.
  
  
            if (variantFieldsets.length > 2) {
              if (variant.available) {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
              }
            }
          });
        } //Second Radio Option
  
  
        if (index === 1) {
          //console.log('fire option 2');
          var _remainingVariants;
  
          if (variantFieldsets.length === 2) {
            //if two variants, then find all the variants from option2 that match the selected radio option, and sort by unavailable first.
            _remainingVariants = getVariantData().filter(function (variant) {
              return variant.option2 === checkedBtns[1].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          } else if (variantFieldsets.length > 2) {
            //if three variants, find all the variants from option2 and option3 that match the selected values for 2 & 3, and sort by unavailable first.
            _remainingVariants = getVariantData().filter(function (variant) {
              return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
            }).sort(function (variant) {
              return variant.available ? 1 : -1;
            });
          } //console.log(index);
          //console.log({remainingVariants});
  
  
          _remainingVariants.forEach(function (variant) {
            //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
            if (variantFieldsets.length >= 2) {
              if (variant.available) {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
              }
            } //if there is three variants, same as above.
  
  
            if (variantFieldsets.length > 2) {
              if (variant.available) {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
              } else {
                productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
              }
            }
          });
        } //Third Radio Option
  
  
        if (index === 2) {
          //console.log('fire option 3');
          //find all the variants from option3 and option1 that match the selected values for 3 & 1, and sort by unavailable first.
          var _remainingVariants2 = getVariantData().filter(function (variant) {
            return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          }); //console.log(index);
          //console.log({remainingVariants});
  
  
          _remainingVariants2.forEach(function (variant) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
            }
  
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
            }
          });
        }
      });
    }; //BG: For each radio button, attach an event listener that triggers when it's checked/unchecked.  
  
  
    radioBtns.forEach(function (radio) {
      return radio.addEventListener('change', function () {
        //After a selection has been made, gather all checked options.
        var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked'); //By default, we assume there will always be one radio button checked.
  
        var optionCombine = radioBtnsChecked[0].value; //console.log(radioBtnsChecked[0].value);
        //if there are two variant fields, we assume there will be two checked radio btns so add this to the variable.
  
        if (variantFieldsets.length >= 2) {
          //console.log(radioBtnsChecked[1].value);
          optionCombine += ' / ' + radioBtnsChecked[1].value;
        } //if there are three variant fields, we assume there will be three checked radio btns so add this to the variable.
  
  
        if (variantFieldsets.length > 2) {
          //console.log(radioBtnsChecked[2].value);
          optionCombine += ' / ' + radioBtnsChecked[2].value;
        } //console.log({optionCombine});
        //BG: with the combined result we search for the variant based on the variant.title.
  
  
        var combineVariant = getVariantData().filter(function (variant) {
          return variant.title === optionCombine;
        }); //console.log({combineVariant});
  
        finalVariant(combineVariant[0]);
        fieldsetLegend(radio);
        remainingOptions(radioBtnsChecked);
      });
    });
    var currentRadioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
    remainingOptions(currentRadioBtnsChecked);
  }; //only trigger the productVariants if there is more than one variant.
  
  
  var variantSingle = document.querySelector('.single-variant');
  
  if (!variantSingle) {
    productVariants();
  } // ---------------------------------------------------------------------------
  // Product Page - Updating Price in Add to Cart Button on Qty Change
  // ---------------------------------------------------------------------------
  
  
  var priceCalculation = function priceCalculation() {
    var cartActions = document.querySelectorAll('.js-prod-btn-group');
    cartActions.forEach(function (group) {
      var price = parseInt(group.getAttribute('data-cv-price')),
          quantity = parseInt(group.querySelector('.js-input-quantity').value),
          displayPrice;
      var btnPrice = group.querySelector('.js-total-price');
      displayPrice = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(price * quantity, window.theme.moneyFormat).replace('.00', '');
      //btnPrice.innerHTML = displayPrice;
    });
  
  };
  
  var button_qty = document.querySelectorAll('.js-btn-quantity');
  button_qty.forEach(function (element) {
    element.addEventListener('click', function (event) {
      priceCalculation();
  
      const qtyinputs = document.querySelector('.product-info .js-input-quantity').value;
    let incVatPrice = document.querySelector('.js-product-price.js-inc-vat').dataset.price;
  
    let exVatPrice = document.querySelector('.js-product-price.js-ex-vat').dataset.price;
  
    if(document.querySelector('.js-product-compare-at-price.js-inc-vat')){
     
    let incVatCompPrice = document.querySelector('.js-product-compare-at-price.js-inc-vat').dataset.compareprice;
    let price =  (qtyinputs*incVatPrice);
    let compprice = (qtyinputs*incVatCompPrice);
  
      document.querySelector('.js-product-price.js-inc-vat').innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(price, window.theme.moneyFormat).replace('.00', '');
      document.querySelector('.js-product-compare-at-price.js-inc-vat').innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(compprice, window.theme.moneyFormat).replace('.00', '');
    } else {
      let price =  (qtyinputs*incVatPrice);
      document.querySelector('.js-product-price.js-inc-vat').innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(price, window.theme.moneyFormat).replace('.00', '');
    }
  
    if(document.querySelector('.js-product-compare-at-price.js-ex-vat')){
      
    let exVatCompPrice = document.querySelector('.js-product-compare-at-price.js-ex-vat').dataset.compareprice;
    let exprice =  (qtyinputs*exVatPrice);
    let excompprice = (qtyinputs*exVatCompPrice);
    document.querySelector('.js-product-price.js-ex-vat').innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(exprice, window.theme.moneyFormat).replace('.00', '');
      document.querySelector('.js-product-compare-at-price.js-ex-vat').innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(excompprice, window.theme.moneyFormat).replace('.00', '');
    } else {
      let exprice =  (qtyinputs*exVatPrice);
  
      document.querySelector('.js-product-price.js-ex-vat').innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(exprice, window.theme.moneyFormat).replace('.00', '');
      
    }
    });
  }); // ---------------------------------------------------------------------------
  // Product Images - Load More
  // ---------------------------------------------------------------------------
  
  var product_images = document.querySelector(".product-images-container");
  var images = product_images ? Array.from(product_images.querySelectorAll(".product-image")) : [];
  var loadMore = document.querySelector(".js-load-more"); // MB: Addition - Products to show and products shown initially. Values set in Product by customer.
  
  var images_shown = document.querySelector(".images-shown").value;
  var images_toshow = document.querySelector(".images-toshow").value; // MB: Addition - Span inside button that shows images left. 
  
  var images_left = document.querySelector(".images-left");
  var images_count_text = document.querySelector('.images-count-text');
  var hiddenClass = "lg:hidden"; // MB: Revealing images based on client selection. images_shown is how many images the client
  // has set to show on page load. 
  
  images.splice(0, images_shown).forEach(function (elem) {
    return elem.classList.remove(hiddenClass);
  }); // MB: On button click count how many images have the class of hiddenClass.
  
  if( loadMore ){
    loadMore.addEventListener('click', hidden_image_count); // MB: Revealing images based on client selection. images_toshow is how many images the client
  
  // wants to show on button click.
  
  if (images.length == 0) {
    loadMore.classList.add(hiddenClass);
  }
  
  loadMore.addEventListener('click', function (e) {
    e.preventDefault();
    images.splice(0, images_toshow).forEach(function (elem) {
      return elem.classList.remove(hiddenClass);
    });
  
    if (images.length == 0) {
      loadMore.classList.add(hiddenClass);
    }
  }); 
  }
  // MB: Counting how many product images have a class of hidden. If its less than amount to show then change
  // the amount shown inside the button
  
  function hidden_image_count() {
    var count = 0;
  
    var _iterator = _createForOfIteratorHelper(images),
        _step;
  
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var image = _step.value;
  
        if (image.classList.contains(hiddenClass)) {
          count++;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  
    count -= images_toshow; // MB: If the amount of images remaining is less than the amount set by the client then change the value
    // to show the amount of images left.
  
    if (count < images_toshow) {
      images_left.innerHTML = count;
    } // MB: If image count is equal to 1 then change from images (plural) to image (singular)
  
  
    if (count == 1) {
      images_count_text.innerHTML = 'image';
    }
  } // ---------------------------------------------------------------------------
  // Product Images - Load More
  // ---------------------------------------------------------------------------
  
  
  setTimeout(function () {
    // MB: Find all div elements with class "adp-vol-wrapper"
    var adpVolWrappers = document.querySelectorAll('.adp-vol-wrapper'); // MB: Loop through each element and add a new div element after it
  
    adpVolWrappers.forEach(function (adpVolWrapper) {
      var volumeContentTR = document.createElement('tr');
      var volumeContent = document.createElement('div');
      volumeContent.textContent = 'Need more?';
      volumeContent.classList.add('cc-h-full', 'py-2.5', 'px-4', 'flex', 'flex-col', 'cc-text-center', 'w-full', 'cc-text-[13px]', 'cc-font-medium', 'text-primary', 'items-center', 'justify-center', 'gap-2');
      var volumeLink = document.createElement('a');
      volumeLink.href = 'https://displaysense.customerdesk.io/#rp-customer-widget-faq-c383772e-0424-4b62-82d3-7949e8f366b1';
      volumeLink.textContent = 'Enquire Now';
      volumeLink.classList.add('cc-text-[#759C98]', 'transition', 'duration-300', 'ease-in-out', 'hover:text-primary', 'cc-underline');
      volumeContent.appendChild(volumeLink);
      volumeContentTR.appendChild(volumeContent)
      adpVolWrapper.querySelector('.adp-discount-table tbody').appendChild(volumeContentTR);
    });
  }, 1000); // ---------------------------------------------------------------------------
  // Product Swatches - Colours
  // ---------------------------------------------------------------------------
  
  /**
   * BG: Build the Colour Swatch based on the returned result from the ajax
   */
  
  function outputColourSwatchProductsPage(json, currentProductID, sizePresent) {
    var markup = '<div class="product-colours cc-gap-x-[30px] cc-gap-y-[10px]">';
  
    if (sizePresent == true) {
      var colourArray = [];
      var orderedProducts = [];
      var productsArray = Object.values(json.products);
      productsArray.sort(function (a, b) {
        return parseInt(a.size) - parseInt(b.size);
      });
  
      for (var i = 0; i < productsArray.length; i++) {
        var productID = parseInt(productsArray[i]['id']);
        var productColour = productsArray[i]['colour'];
        var productURL = productsArray[i]['url'];
        var productSizes = productsArray['size'];
        var productSize = productsArray[i]['size'];
        var arrayCheck = colourArray.findIndex(function (obj) {
          return obj.colour === productColour;
        });
  
        if (productID === currentProductID) {
          var selectedProductColour = productColour;
          var selectedSize = productSize;
        }
  
        if (arrayCheck == -1) {
          colourArray.push({
            "colour": productColour,
            "url": productURL,
            "size": productSize
          });
        }
  
        orderedProducts.push({
          "id": productID,
          "colour": productColour,
          "url": productURL,
          "size": productSize
        });
      }
  
      colourArray.forEach(function (colour) {
        var classes = 'btn-colour-swatch ' + colour.colour.toLowerCase() + ' cc-size-6 rounded-full border border-gray-100 cursor-pointer';
        var selectedProduct = null; // Loop through the sorted products array and find the first matching product
  
        for (var i = 0; i < productsArray.length; i++) {
          var productColour = productsArray[i]['colour'];
          var productSize = productsArray[i]['size']; // Check if the product has the same colour and size as the selected product
  
          if (productColour === colour.colour && productSize === selectedSize) {
            selectedProduct = productsArray[i];
            break; // Exit the loop since we found a match
          }
        }
  
        if (classes.includes(selectedProductColour)) {
          classes += ' current'; // add the 'current' class if it contains the selected product colour
          
          
          document.querySelector('.product-colours-container .cc__current').innerText = colour.colour;
        }
  
        if (selectedProduct) {
          markup += '<p class="cc-flex cc-items-center cc-gap-[5px]"><a href="' + selectedProduct.url + '" class="' + classes + '"></a><span class="cc-capitalize cc-text-[17px]">'+colour.colour+'</span></p>';
        } else {
          // Handle case when no matching product is found
          markup += '<p class="cc-flex cc-items-center cc-gap-[5px]"><a href="' + colour.url + '" class="' + classes + '"></a></p>';
        }
      });
    } else {
      var colourArray = []; // Create a new array to store the products in the desired order
  
      var orderedProducts = []; // Convert the products object to an array to allow sorting
  
      var productsArray = Object.values(json.products); // Sort the products array by size numerically
  
      productsArray.sort(function (a, b) {
        return parseInt(a.size) - parseInt(b.size);
      }); // Loop through the sorted products array and add each product to the orderedProducts array
  
      for (var i = 0; i < productsArray.length; i++) {
        var productID = parseInt(productsArray[i]['id']);
        var productColour = productsArray[i]['colour'];
        var productURL = productsArray[i]['url'];
        var productSize = productsArray[i]['size'];
        var arrayCheck = colourArray.findIndex(function (obj) {
          return obj.colour === productColour;
        });
  
        if (productID === currentProductID) {
          var selectedProductColour = productColour;
        }
  
        if (arrayCheck == -1) {
          colourArray.push({
            "colour": productColour,
            "url": productURL,
            "size": productSize
          });
        }
  
        orderedProducts.push({
          "id": productID,
          "colour": productColour,
          "url": productURL,
          "size": productSize
        });
      }
  
      colourArray.forEach(function (colour) {
        // Add option product to the list and select markup
        var classes = 'btn-colour-swatch ' + colour.colour.toLowerCase() + ' cc-size-6 rounded-full border border-gray-100 mr-2.5 cursor-pointer';
  
        if (classes.includes(selectedProductColour)) {
          classes += ' current'; // add the 'current' class if it contains the selected product colour
          document.querySelector('.product-colours-container .cc__current').innerText = colour.colour;
        }
        
          markup += '<p class="cc-flex cc-items-center cc-gap-[5px]"><a href="' + colour.url + '" class="' + classes + '"></a><span class="cc-capitalize cc-text-[17px]">'+colour.colour+'</span></p>';
      });
    }
  
    setTimeout(function () {
      var btnSizeSwatches = document.querySelectorAll('.btn-size-swatch');
      btnSizeSwatches.forEach(function (swatch) {
        if (swatch.classList.contains(selectedProductColour)) {
          swatch.classList.remove('hidden');
          swatch.parentElement.querySelector('span').classList.remove('hidden');
        } else {
          swatch.parentElement.remove();
        }
      });
    }, 300); //close list and select markup
  
    markup += '</div>';
    var productColoursContainer = document.querySelector('.product-colours-container');
    var titleElement = productColoursContainer.querySelector('.title');
    titleElement.insertAdjacentHTML('afterend', markup);
  }
  
  function productMatchingColours() {
    var productColoursContainer = document.querySelector('.product-colours-container');
    var sizeContainer = document.querySelector('.product-sizes-container');
  
    if (sizeContainer) {
      var sizePresent = true;
    } else {
      var sizePresent = false;
    }
  
    if (productColoursContainer) {
      var productColourTag = productColoursContainer.getAttribute('data-colour-group');
      var currentProductID = parseInt(productColoursContainer.getAttribute('data-current-product-id'));
  
      if (productColoursContainer.getAttribute('data-colour-group')) {
        var xhr = new XMLHttpRequest();
  
        xhr.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            var data = this.responseText;
  
            if (data) {
              try {
                var json = JSON.parse(data);
              } catch (e) {
                var json = null;
              }
            }
  
            if (json) {
              outputColourSwatchProductsPage(json, currentProductID, sizePresent);
            
            }
          }
        };
  
        xhr.open('GET', '/collections/all/' + productColourTag + '?view=swatch', true);
        xhr.send();
      }
    }
  } // ---------------------------------------------------------------------------
  // Product Swatches - Sizes
  // ---------------------------------------------------------------------------
  
  /**
   * BG: Build the Size Swatch based on the returned result from the ajax
   */
  
  
  function outputSizeSwatchProductsPage(json, currentProductID) {
    var markup = '<div class="product-sizes flex flex-wrap cc-gap-x-[30px] cc-gap-y-[10px]">'; // sort products by size
  
    var sortedProducts = json.products.sort(function (a, b) {
      // Check if both products have sizes
      if (a.size && b.size) {
        // Get the numeric values of the sizes (if they start with a number)
        var aSizeNumber = parseInt(a.size);
        var bSizeNumber = parseInt(b.size); // Check if the numeric values are valid (i.e., not NaN)
  
        if (!isNaN(aSizeNumber) && !isNaN(bSizeNumber)) {
          // Compare the numeric values to determine the order of the products
          return aSizeNumber - bSizeNumber;
        } else {
          // Compare the sizes lexicographically
          return a.size.localeCompare(b.size);
        }
      } // If either product does not have a size, keep the order unchanged
  
  
      return 0;
    }); // for each product
  
    for (var key in sortedProducts) {
      var product = sortedProducts[key];
      var productSize = product['size'];
      var productTitle = product['title'];
      var productURL = product['url'];
      var productAvailable = product['available'];
      var productID = parseInt(product['id']);
      var productColour = product['colour'];
      var activeClass = '';
      var currentProduct = false;
  
      if (sortedProducts.length) {
        // if current product ID matches the product ID in the loop, set active class and selected option.
        if (productID === currentProductID) {
          activeClass = ' current';
          currentProduct = true;
          
          document.querySelector('.product-sizes-container .cc__current').innerText = productSize;
        }
  
        if (productSize) {
          // add product size to markup
          markup += '<p class="cc-flex cc-items-center cc-gap-[5px]"><a href="' + productURL + '" class="btn-size-swatch cc-size-6 rounded-full border border-gray-100 cursor-pointer' + activeClass + ' ' + productColour + '" data-product-available="' + productAvailable + '" data-product-size="' + productSize + '" aria-label="View ' + productTitle + ' in ' + productSize + '" tabindex="0"></a><span class="cc-capitalize cc-text-[17px]">'+productSize+'</span></p>';
        }
      }
    } // close list and select markup
  
  
    markup += '</div>';
    var productSizesContainer = document.querySelector('.product-sizes-container');
    var titleElement = productSizesContainer.querySelector('.title');
    titleElement.insertAdjacentHTML('afterend', markup);
  }
  
  function productMatchingSizes() {
    var productSizesContainer = document.querySelector('.product-sizes-container');
  
    if (productSizesContainer) {
      var productSizeTag = productSizesContainer.getAttribute('data-size-group');
      var currentProductID = parseInt(productSizesContainer.getAttribute('data-current-product-id'));
  
      if (productSizesContainer.getAttribute('data-size-group')) {
        var xhr = new XMLHttpRequest();
  
        xhr.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            var data = this.responseText;
  
            if (data) {
              try {
                var json = JSON.parse(data);
              } catch (e) {
                var json = null; // meh
              }
            }
  
            if (json) {
              outputSizeSwatchProductsPage(json, currentProductID);
            }
          }
        };
  
        xhr.open('GET', '/collections/all/' + productSizeTag + '?view=swatch', true);
        xhr.send();
      }
    }
  }
  
  productMatchingSizes();
  productMatchingColours();
  })();
  
  /******/ })()
  ;